// extracted by css-extract-rspack-plugin
export default {"infoLinesItem":"infoLinesItem-RHE7kd","infoLinesItemLabel":"infoLinesItemLabel-g1RC5f text-base-regular","infoLinesItemValue":"infoLinesItemValue-hapTMm text-base-semibold"};